import SourceFlowText from "@sourceflow-uk/sourceflowtext";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import {
    Container
} from "reactstrap";
import styles from "./styles.module.scss";
import Link from "next/link";

export default function NewSimpleContent({
    global,
    pathPrefix,
    customClass = "",
    content,
    content_2,
    editableText = true,
    dual_column = false,
    border_bottom = false,
    editableDualText = true
}) {
    return (
        content && (
            <section className={`${styles.root} ${customClass}`}>
                <Container>
                    {content && (
                        editableText ? (
                            dual_column ?
                                <div className="d-flex gap-5 flex-wrap flex-lg-nowrap">
                                    <div className="column">
                                        {editableDualText ?
                                            <SourceFlowText
                                                global={global}
                                                path={`${pathPrefix}.content_1`}
                                                type="html"
                                            >
                                                {content}
                                            </SourceFlowText> :
                                            <div dangerouslySetInnerHTML={{ __html: content }} />
                                        }
                                    </div>
                                    <div className="column">
                                        {editableDualText ?
                                            <SourceFlowText
                                                global={global}
                                                path={`${pathPrefix}.content_2`}
                                                type="html"
                                            >
                                                {content_2}
                                            </SourceFlowText>
                                            :
                                            <div dangerouslySetInnerHTML={{ __html: content_2 }} />
                                        }
                                    </div>
                                </div>
                                :
                                <div className="mainContent">
                                    <SourceFlowText
                                        global={global}
                                        path={`${pathPrefix}.content`}
                                        type="html"
                                    >
                                        {content}
                                    </SourceFlowText>
                                </div>
                        ) : (
                            <div className="mainContent" dangerouslySetInnerHTML={{ __html: content }} />
                        )
                    )}

                </Container>
                {border_bottom && (
                    <Container>
                        <hr />
                    </Container>
                )}
            </section>
        )
    );
}
